import{unmountComponentAtNode}from"react-dom";export default unmountComponentAtNode;